import { HttpContext } from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideAuth,
  providePortalSessionInitialization,
  resolveAuthApiUrl,
  SKIP_ACCESS_TOKEN,
} from '@system-dyg/core/auth';
import { provideDemoApi } from '@system-dyg/core/demo-api';
import { provideSettingsApi } from '@system-dyg/features/admin/data-access';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(appRoutes),
    provideAuth({
      apiUrl: resolveAuthApiUrl(environment.authApiUrl),
      context: 'settings',
      loginUrl: environment.authUrl,
    }),
    provideDemoApi({
      baseUrl: environment.demoApiUrl,
      enabled:
        !environment.production &&
        (environment.demoFeaturesEnabled || environment.demoAdminEnabled),
      requestContext: new HttpContext().set(SKIP_ACCESS_TOKEN, true),
    }),
    provideSettingsApi(environment.settingsApiUrl),
    providePortalSessionInitialization(),
  ],
};
